import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "@studio-freight/lenis";

import "@/App.css";

import Navbar from "@/components/zenoviq/Navbar";
import Hero from "@/components/zenoviq/Hero";
import Services from "@/components/zenoviq/Services";
import WhyChoose from "@/components/zenoviq/WhyChoose";
import About from "@/components/zenoviq/About";
import FAQ from "@/components/zenoviq/FAQ";
import Contact from "@/components/zenoviq/Contact";
import Footer from "@/components/zenoviq/Footer";

import PrivacyPolicy from "@/components/zenoviq/PrivacyPolicy";
import TermsConditions from "@/components/zenoviq/TermsConditions";

import { Toaster } from "@/components/ui/sonner";
import { useLocation } from "react-router-dom";

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");

    const timer = setTimeout(() => {
      const el = document.getElementById(id);

      if (!el) return;

      if (window.__lenis) {
        window.__lenis.scrollTo(el, {
          offset: -64,
          duration: 1,
        });
      } else {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChoose />
        <About />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.9,
      easing: (t) => 1 - Math.pow(1 - t, 3),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.3,
    });

    window.__lenis = lenis;

    let rafId;

    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };

    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App" data-testid="app-root">
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route
            path="/privacy-policy"
            element={
              <>
                <Navbar />
                <PrivacyPolicy />
                <Footer />
              </>
            }
          />

          <Route
            path="/terms-and-conditions"
            element={
              <>
                <Navbar />
                <TermsConditions />
                <Footer />
              </>
            }
          />
        </Routes>

        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;